import request from '@/utils/request';
export var apiUrlConfig = {
  queryUrl: '/channel/sms/list'
};
export var smsRecordApiUrlConfig = {
  queryUrl: '/channel/sms/recordList'
};

/**
 * 详情
 * @param code
 * @constructor
 */
export function info(code) {
  return request({
    url: '/channel/sms/info/' + code,
    method: 'get'
  });
}

/**
 * 新增
 * @param pram
 * @constructor
 */
export function add(pram) {
  return request({
    url: '/channel/sms/save',
    method: 'post',
    data: pram
  });
}

/**
 * 更新
 * @param code
 * @param data
 * @constructor
 */
export function update(code, data) {
  return request({
    url: '/channel/sms/update/' + code,
    method: 'post',
    data: data
  });
}